export const ProductComparison = "3a933df88157064cc866bca3506d76898b7c28b9400ac89d88910622cc186dfa";